module.exports = __webpack_public_path__ + "static/media/ro.ce76b031.svg";